import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "../components/auth/LoginPage";
import Preloader from "../components/layout/Preloader";
import NotFoundPage from "../components/layout/NotFoundPage";
import AdminDashboard from "../AgentWorkspace";

import { fetchJson } from "../lib/fetchJson";

function AppShell() {
  const [currentUser, setCurrentUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");

  useEffect(() => {
    async function bootstrap() {
      try {
        const payload = await fetchJson("/api/accounts/auth/me/");
        if (payload?.user) {
          setCurrentUser(payload.user);
        }
      } catch (requestError) {
        if (requestError.status !== 401) {
          setError(requestError.message);
        }
      } finally {
        setAuthLoading(false);
      }
    }
    bootstrap();
  }, []);

  async function handleLoginSubmit(event) {
    event.preventDefault();
    try {
      setLoggingIn(true);
      setError("");
      const payload = await fetchJson("/api/accounts/auth/login/", {
        method: "POST",
        body: JSON.stringify(loginForm),
      });
      setCurrentUser(payload.user);
      setLoginForm({ username: "", password: "" });
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoggingIn(false);
    }
  }

  async function handleLogout() {
    try {
      await fetchJson("/api/accounts/auth/logout/", { method: "POST" });
    } catch {
      // ignore logout errors
    } finally {
      setCurrentUser(null);
      setError("");
    }
  }

  function handleLoginFieldChange(field, value) {
    setLoginForm((current) => ({ ...current, [field]: value }));
  }

  if (authLoading) {
    return <Preloader visible={true} />;
  }

  return (
    <Routes>
      {/* Root — redirect based on auth state */}
      <Route
        path="/"
        element={<Navigate to={currentUser ? "/support" : "/login"} replace />}
      />

      {/* Login page — redirect to /support if already logged in */}
      <Route
        path="/login"
        element={
          currentUser ? (
            <Navigate to="/support" replace />
          ) : (
            <LoginPage
              error={error}
              loggingIn={loggingIn}
              loginForm={loginForm}
              onChange={handleLoginFieldChange}
              onSubmit={handleLoginSubmit}
            />
          )
        }
      />

      {/* Support CRM — redirect to /login if not logged in */}
      <Route
        path="/support/*"
        element={
          currentUser ? (
            <div className="crm-page">
              <AdminDashboard
                currentUser={currentUser}
                fetchJson={fetchJson}
                onLogout={handleLogout}
                onBack={() => {}}
              />
            </div>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Any other URL */}
      <Route
        path="*"
        element={currentUser ? <NotFoundPage /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
}

export default AppShell;
